import { translateSync as t } from "@opendash/i18n";
import dayjs from "dayjs";
const milliseconds = ["ms", "milliseconds"] as const;
const seconds = ["s", "sec", "sek", "seconds", "sekunden"] as const;
const minutes = ["min", "minutes", "minuten"] as const;
const hours = ["std", "h", "hr", "hrs", "stunden", "hours"] as const;
const days = ["days", "tage"] as const;
const weeks = ["wochen", "weeks"] as const;
const month = ["months", "monate"] as const;
const years = ["jahre", "years"] as const;

export enum TimeMode {
  DurationMode = 0,
  DateMode = 1,
}
export type TimeDisplayMode =
  | "unix"
  | "full"
  | "date"
  | "time"
  | "humanize"
  | "unit";

export type TimeUnit =
  | (typeof milliseconds)[number]
  | (typeof seconds)[number]
  | (typeof minutes)[number]
  | (typeof hours)[number]
  | (typeof days)[number]
  | (typeof weeks)[number]
  | (typeof month)[number]
  | (typeof years)[number];

export const isDateUnit = (unit) => {
  unit = unit.toLowerCase();
  if (milliseconds.indexOf(unit) != -1) {
    return true;
  }
  if (seconds.indexOf(unit) != -1) {
    return true;
  }
  if (minutes.indexOf(unit) != -1) {
    return true;
  }
  if (hours.indexOf(unit) != -1) {
    return true;
  }
  if (days.indexOf(unit) != -1) {
    return true;
  }
  if (weeks.indexOf(unit) != -1) {
    return true;
  }
  if (month.indexOf(unit) != -1) {
    return true;
  }
  if (years.indexOf(unit) != -1) {
    return true;
  }
  return false;
};

export const getTimeString = (
  tMode: TimeMode,
  timeDisplay: TimeDisplayMode,
  unit: TimeUnit,
  cValue: number
) => {
  if (cValue === 0) return "-";
  if (tMode === TimeMode.DurationMode) {
    let date;
    let unitToUse;
    //@ts-expect-error
    if (years.indexOf(unit.toLowerCase()) != -1) {
      //@ts-expect-error
      date = dayjs.duration(cValue, "years");
      unitToUse = "years";
    }
    //@ts-expect-error
    if (month.indexOf(unit.toLowerCase()) != -1) {
      //@ts-expect-error
      date = dayjs.duration(cValue, "months");
      unitToUse = "months";
    }
    //@ts-expect-error
    if (weeks.indexOf(unit.toLowerCase()) != -1) {
      //@ts-expect-error
      date = dayjs.duration(cValue, "weeks");
      unitToUse = "weeks";
    }
    //@ts-expect-error
    if (days.indexOf(unit.toLowerCase()) != -1) {
      //@ts-expect-error
      date = dayjs.duration(cValue, "days");
      unitToUse = "days";
    }
    //@ts-expect-error
    if (hours.indexOf(unit.toLowerCase()) != -1) {
      //@ts-expect-error
      date = dayjs.duration(cValue, "hours");
      unitToUse = "hours";
    }
    //@ts-expect-error
    if (minutes.indexOf(unit.toLowerCase()) != -1) {
      //@ts-expect-error
      date = dayjs.duration(cValue, "minutes");
      unitToUse = "minutes";
    }
    //@ts-expect-error
    if (seconds.indexOf(unit.toLowerCase()) != -1) {
      //@ts-expect-error
      date = dayjs.duration(cValue, "seconds");
      unitToUse = "seconds";
    }
    //@ts-expect-error
    if (milliseconds.indexOf(unit.toLowerCase()) != -1) {
      //@ts-expect-error
      date = dayjs.duration(cValue);
      unitToUse = "milliseconds";
    }

    if (timeDisplay === "full") {
      let string = "";
      string += date.years()
        ? `${date.years()}  ${date.years() > 1 ? t("opendash:ui.year_plural") : t("opendash:ui.year")} `
        : "";
      string += date.months()
        ? `${date.months()}  ${date.months() > 1 ? t("opendash:ui.month_plural") : t("opendash:ui.month")} `
        : "";
      string += date.days()
        ? `${date.days()}  ${date.days() > 1 ? t("opendash:ui.day_plural") : t("opendash:ui.day")} `
        : "";
      string += date.hours()
        ? `${date.hours()}  ${date.hours() > 1 ? t("opendash:ui.hour_plural") : t("opendash:ui.hour")} `
        : "";
      string += date.minutes()
        ? `${date.minutes()}  ${date.minutes() > 1 ? t("opendash:ui.minute_plural") : t("opendash:ui.minute")} `
        : "";
      string += date.seconds()
        ? `${date.seconds()}  ${date.seconds() > 1 ? t("opendash:ui.second_plural") : t("opendash:ui.second")} `
        : "";

      if (string === "") {
        string += `${date.milliseconds()}  ${date.milliseconds() > 1 ? t("opendash:ui.millisecond_plural") : t("opendash:ui.millisecond")} `;
      }
      return string;
    }

    if (timeDisplay === "unit")
      return date.as(unitToUse).toFixed(2) + " " + unit;
    if (timeDisplay === "humanize") return date.humanize();
    if (timeDisplay === "unix") return Math.floor(date.valueOf()) + " ms";
  } else {
    const date = dayjs(cValue);
    //["unix", "full", "date", "time", "humanize"];
    if (timeDisplay === "unix") return "" + date.valueOf();
    if (timeDisplay === "full") return date.format("DD.MM.YYYY @ HH:mm:ss");
    if (timeDisplay === "date") return date.format("DD.MM.YYYY");
    if (timeDisplay === "time") return date.format("HH:mm:ss");
    // @ts-expect-error
    if (timeDisplay === "humanize") return date.fromNow();
  }
};
export const isSecondsUnit = (unit) => {
  return seconds.indexOf(unit.toLowerCase()) != -1;
};
export const isMillisecondsUnit = (unit) => {
  return milliseconds.indexOf(unit.toLowerCase()) != -1;
};
export const isMinutesUnit = (unit) => {
  return minutes.indexOf(unit.toLowerCase()) != -1;
};
export const isHoursUnit = (unit) => {
  return hours.indexOf(unit.toLowerCase()) != -1;
};
export const isDaysUnit = (unit) => {
  return days.indexOf(unit.toLowerCase()) != -1;
};
export const isWeeksUnit = (unit) => {
  return weeks.indexOf(unit.toLowerCase()) != -1;
};
export const isMonthUnit = (unit) => {
  return month.indexOf(unit.toLowerCase()) != -1;
};
export const isYearsUnit = (unit) => {
  return years.indexOf(unit.toLowerCase()) != -1;
};
